import { render, staticRenderFns } from "./RepairSlipLink.vue?vue&type=template&id=01c6c18e&scoped=true"
import script from "./RepairSlipLink.vue?vue&type=script&lang=js"
export * from "./RepairSlipLink.vue?vue&type=script&lang=js"
import style0 from "./RepairSlipLink.vue?vue&type=style&index=0&id=01c6c18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6c18e",
  null
  
)

export default component.exports